(() => {
  const HM = (window.HM = window.HM || {});

  const money = (cents) => {
    // Deutsches Format „49,99 €" fest im Theme (Kevin 07.10.; Shop-Format im Admin nicht umstellbar), wie money_without_currency + ' €' im Liquid
    const fmt = '{{amount_with_comma_separator}} €';
    const amount = (Number(cents) / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(cents) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  };
  HM.money = money;

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const script = document.querySelector('[data-variants]');
      this.variants = script ? JSON.parse(script.textContent) : [];
      this.addEventListener('change', () => this.update(true));
      this.addEventListener('click', (e) => {
        const tab = e.target.closest('.vpicker__fit-tab');
        if (tab) this.applyFit(tab.dataset.fit);
      });
      // Start-Tab = Art der schon gewählten Größe (Deep-Link ?variant= auf 152 darf nicht auf Erwachsene springen), sonst Erwachsene
      if (this.querySelector('.vpicker__fit-tab')) {
        const sel = this.querySelector('input[type="radio"]:checked');
        const lab = sel && this.querySelector(`label[for="${CSS.escape(sel.id)}"][data-kind]`);
        this.applyFit(lab ? lab.dataset.kind : 'adult');
      }
      this.update(false);
    }
    applyFit(kind) {
      this.querySelectorAll('.vpicker__fit-tab').forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.fit === kind)));
      const fs = this.querySelector('.vpicker__fit-tab') && this.querySelector('.vpicker__fit-tab').closest('fieldset');
      if (!fs) return;
      let checkedHidden = false;
      fs.querySelectorAll('label[data-kind]').forEach((label) => {
        const show = label.dataset.kind === kind;
        label.toggleAttribute('hidden', !show);
        const input = fs.querySelector(`#${CSS.escape(label.getAttribute('for'))}`);
        if (input && input.checked && !show) checkedHidden = true;
      });
      // Tab-Wechsel wählt nicht automatisch eine Größe (keine Vorauswahl seit 07.10.): versteckte Wahl wird geleert
      if (checkedHidden) {
        fs.querySelectorAll('input[type="radio"]:checked').forEach((i) => { i.checked = false; });
        this.update(true);
      }
    }
    // Fehlt noch eine Wahl (z. B. Größe), markieren + hinscrollen und true liefern; Aufrufer brechen dann ab
    flagMissing() {
      const fs = Array.from(this.querySelectorAll('fieldset')).find((f) => !f.querySelector('input[type="radio"]:checked'));
      if (!fs) return false;
      fs.classList.remove('is-missing');
      void fs.offsetWidth;
      fs.classList.add('is-missing');
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return true;
    }
    selectedOptions() {
      return Array.from(this.querySelectorAll('fieldset')).map((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }
    matches(variant, options) {
      return options.every((o, i) => o === null || variant.options[i] === o);
    }
    markAvailability(options) {
      this.querySelectorAll('fieldset').forEach((fs, idx) => {
        fs.querySelectorAll('input[type="radio"]').forEach((input) => {
          const probe = options.slice();
          probe[idx] = input.value;
          const v = this.variants.find((x) => this.matches(x, probe));
          const label = fs.querySelector(`label[for="${input.id}"]`);
          if (label) label.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    update(pushState) {
      const options = this.selectedOptions();
      const incomplete = options.some((o) => o === null);
      const variant = incomplete ? null : this.variants.find((v) => this.matches(v, options)) || null;
      this.markAvailability(options);
      this.querySelectorAll('fieldset').forEach((fs) => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        const out = fs.querySelector('[data-selected-option]');
        if (checked) fs.classList.remove('is-missing');
        if (!out) return;
        out.textContent = checked ? checked.value : out.dataset.pendingLabel || '';
        out.classList.toggle('is-pending', !checked);
      });
      if (incomplete && pushState && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.delete('variant');
        window.history.replaceState({}, '', url);
      }
      if (variant) {
        const idInput = document.querySelector('[data-variant-id]');
        if (idInput) idInput.value = variant.id;
        // Nur Anzeige-Spans, NICHT die option/input-Elemente, die data-price als Datenattribut tragen (Set-Block)
        document.querySelectorAll('[data-price]:not(option):not(input)').forEach((n) => {
          if (n.closest('.pcard')) return; // Produktkarten (Passt dazu/Upsell) zeigen FREMDE Produkte - nie mit dem PDP-Variantenpreis überschreiben
          if (n.dataset.teamFest) return; // fester Vertragspreis (B2B), variantenunabhängig
          const teamFaktor = parseFloat(n.dataset.teamFaktor || '');
          n.textContent = money(teamFaktor ? Math.round(variant.price * teamFaktor) : variant.price);
        });
        if (pushState && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }
      // Status-Zeile ist seit 01.10. statisch ("Bestellbar - Wird für dich produziert"), kein [data-stock] mehr
      const btn = document.querySelector('[data-atc-main]');
      const label = document.querySelector('[data-atc-label]');
      if (btn) {
        if (incomplete) {
          // Klickbar lassen: ein Klick zeigt, was fehlt (flagMissing), statt still nichts zu tun
          btn.disabled = false;
          btn.dataset.needsChoice = '1';
          if (label) label.textContent = btn.dataset.labelChoose || btn.dataset.labelAdd;
        } else {
          delete btn.dataset.needsChoice;
          const ok = !!(variant && variant.available);
          btn.disabled = !ok;
          if (label) label.textContent = !variant ? btn.dataset.labelUnavailable : ok ? btn.dataset.labelAdd : btn.dataset.labelSoldOut;
        }
      }
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant, options } }));
    }
  }
  if (!customElements.get('variant-picker')) customElements.define('variant-picker', VariantPicker);

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = this.form.querySelector('[data-atc-main]');
        if (btn && btn.disabled) return;
        const picker = this.form.querySelector('variant-picker');
        if (picker && picker.flagMissing && picker.flagMissing()) return;
        // Team-Bestellung an der PDP erkannt: über der Grenze einmal den Vereinsweg erklären
        const qty = this.form.querySelector('input[name="quantity"][data-club-max]');
        if (qty && Number(qty.value) > Number(qty.dataset.clubMax || 5) && !this.teamOk) {
          const dlg = document.getElementById('pdp-team');
          if (dlg && typeof dlg.open === 'function') { dlg.open(); return; }
        }
        if (btn) btn.setAttribute('aria-busy', 'true');
        try {
          await HM.cart.add(new FormData(this.form));
        } catch (err) {
          HM.notice(err.message);
        } finally {
          if (btn) btn.removeAttribute('aria-busy');
        }
      });
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  // „Alles in den Warenkorb legen" aus dem PDP-Team-Dialog: direkt hinzufügen (ohne Drawer),
  // dann im selben Dialog die nächsten Schritte anbieten (Nummern konfigurieren / Weiter einkaufen)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-pdp-team-continue]');
    if (!btn) return;
    const pf = document.querySelector('product-form');
    const form = pf && pf.querySelector('form');
    const dlg = document.getElementById('pdp-team');
    if (!form || !dlg) return;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    try {
      const res = await fetch(`${root}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!res.ok) {
        const j = await res.json().catch(() => ({}));
        throw new Error(j.description || j.message || 'Konnte nicht in den Warenkorb legen.');
      }
      pf.teamOk = true;
      try {
        const cartRes = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await cartRes.json();
        document.querySelectorAll('[data-cart-count]').forEach((n) => { n.textContent = cart.item_count; });
      } catch (err) { /* Zähler ist nur Kosmetik */ }
      const start = dlg.querySelector('[data-pdp-team-start]');
      const done = dlg.querySelector('[data-pdp-team-done]');
      if (start) start.hidden = true;
      if (done) done.hidden = false;
    } catch (err) {
      HM.notice(err.message);
    } finally {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  });

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-btn]');
    if (!b) return;
    const input = b.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    const max = Number(input.max) || Infinity;
    input.value = Math.min(max, Math.max(1, Number(input.value) + Number(b.dataset.qtyBtn)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Fan-Weg: Beflockung „mit" zeigt Name/Nummer-Felder und fixiert die Menge auf 1
  document.addEventListener('change', (e) => {
    const radio = e.target.closest('[data-befl]');
    if (!radio) return;
    const wrap = document.querySelector('[data-lip-wrap]');
    if (!wrap) return;
    const mit = radio.value === 'mit' && radio.checked;
    wrap.toggleAttribute('hidden', !mit);
    wrap.querySelectorAll('input').forEach((i) => { i.disabled = !mit; if (!mit) i.value = ''; });
    const qty = document.querySelector('input[name="quantity"]');
    if (qty) {
      if (mit) { qty.value = '1'; qty.max = '1'; } else { qty.removeAttribute('max'); }
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const hint = document.querySelector('[data-single-hint]');
    if (hint) hint.hidden = !mit;
  });
  document.addEventListener('DOMContentLoaded', () => {
    const wrap = document.querySelector('[data-lip-wrap]');
    if (wrap) wrap.querySelectorAll('input').forEach((i) => { i.disabled = true; });
  });


  class HmSet extends HTMLElement {
    connectedCallback() {
      this.basePrice = Number(this.dataset.basePrice || 0);
      this.addEventListener('change', (e) => {
        const sel = e.target.closest('select[data-set-item]');
        if (sel) {
          const priceEl = sel.closest('.pset__item')?.querySelector('[data-set-item-price]');
          const opt = sel.selectedOptions[0];
          if (priceEl && opt) priceEl.textContent = money(opt.dataset.price);
          // Kunde hat selbst gewählt: Auto-Sync pausiert bis zum nächsten Trikot-Wechsel
          if (e.isTrusted) sel.dataset.userSet = '1';
          this.reflectSize(sel);
        }
        this.updateTotal();
      });
      // Größen-Chip auf-/zuklappen, Pill-Wahl schreibt ins Select (Select bleibt die Formular-Wahrheit)
      this.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-size-chip]');
        if (chip) {
          const pills = chip.closest('[data-size-pick]')?.querySelector('[data-size-pills]');
          if (!pills) return;
          const open = pills.hidden;
          pills.hidden = !open;
          chip.setAttribute('aria-expanded', String(open));
          return;
        }
        const pill = e.target.closest('[data-size-pill]');
        if (pill) {
          const pick = pill.closest('[data-size-pick]');
          const sel = pick.querySelector('select[data-set-item]');
          if (!sel) return;
          sel.value = pill.dataset.value;
          sel.dataset.userSet = '1'; // manuelle Wahl gilt bis zum nächsten Trikot-Wechsel
          sel.dispatchEvent(new Event('change', { bubbles: true }));
          // Offene Pill-Reihen (data-pick-open) bleiben stehen, nur Chip-Modus klappt zu
          if (!('pickOpen' in pick.dataset)) {
            const pills = pick.querySelector('[data-size-pills]');
            if (pills) pills.hidden = true;
            pick.querySelector('[data-size-chip]')?.setAttribute('aria-expanded', 'false');
          }
        }
      });
      document.addEventListener('variant:change', (e) => {
        const v = e.detail.variant;
        if (!v) return;
        this.basePrice = Number(v.price);
        const baseEl = this.querySelector('[data-set-base-price]');
        if (baseEl) baseEl.textContent = money(v.price);
        // Kevins Regel 01.10.: Ein Trikot-Größenwechsel setzt die Partner-Größen IMMER neu —
        // die manuelle Wahl gilt nur, bis oben eine andere Trikotgröße gewählt wird
        this.querySelectorAll('select[data-set-item]').forEach((s) => { delete s.dataset.userSet; });
        this.syncSizes(v.options && v.options[0]);
        this.updateTotal();
      });
      const btn = this.querySelector('[data-set-add]');
      if (btn) btn.addEventListener('click', async () => {
        // Ohne gewählte Trikotgröße kein Set (sonst landete still die erste Größe im Korb)
        const picker = document.querySelector('variant-picker');
        if (picker && picker.flagMissing && picker.flagMissing()) return;
        const idInput = document.querySelector('[data-variant-id]');
        const items = [];
        if (idInput) {
          const item = { id: Number(idInput.value), quantity: 1 };
          // Beflockung „mit": Rückenname/-nummer wandern mit aufs Trikot (flockSync zieht den Aufpreis nach)
          const props = {};
          document.querySelectorAll('[data-lip-wrap] input').forEach((i) => {
            if (!i.disabled && i.value) props[i.name.replace(/^properties\[|\]$/g, '')] = i.value;
          });
          if (Object.keys(props).length) item.properties = props;
          items.push(item);
        }
        this.querySelectorAll('[data-set-item]').forEach((el) => {
          if (el.value) items.push({ id: Number(el.value), quantity: 1 });
        });
        btn.setAttribute('aria-busy', 'true');
        try {
          await HM.cart.addItems(items);
        } catch (err) {
          HM.notice(err.message);
        } finally {
          btn.removeAttribute('aria-busy');
        }
      });
      // Aufwertung: mit JS Chip bzw. offene Pills statt Select (ohne JS bleibt das native Dropdown bedienbar).
      // Hybrid 01.10.: wenige Größen (data-pick-open, z. B. Stutzen S/M/L) → Pills dauerhaft offen, kein Chip.
      this.querySelectorAll('[data-size-pick]').forEach((pick) => {
        const sel = pick.querySelector('select[data-set-item]');
        const chip = pick.querySelector('[data-size-chip]');
        if (!sel || !chip) return;
        sel.hidden = true;
        sel.setAttribute('tabindex', '-1');
        if ('pickOpen' in pick.dataset) {
          const pills = pick.querySelector('[data-size-pills]');
          if (pills) pills.hidden = false;
        } else {
          chip.hidden = false;
        }
        this.reflectSize(sel);
      });
      // Startzustand: Partner-Größen an die vorausgewählte Trikot-Größe angleichen (ohne Aufblinken)
      const checked = document.querySelector('variant-picker input[type="radio"]:checked');
      this.syncSizes(checked && checked.value, false);
      this.updateTotal();
    }
    // Chip-Text + aktive Pill an den Select-Stand angleichen
    reflectSize(sel) {
      const pick = sel.closest('[data-size-pick]');
      if (!pick) return;
      const opt = sel.selectedOptions[0];
      const cur = pick.querySelector('[data-size-current]');
      if (cur && opt) cur.textContent = opt.textContent.trim();
      pick.querySelectorAll('[data-size-pill]').forEach((p) => {
        p.classList.toggle('is-active', p.dataset.value === sel.value);
      });
    }
    // Stutzen-Mapping (Kevin 01.10.): unter Trikot 154 → S, darunter von M (164/XS/S) → M, ab M → L; Hosen 1:1 gleiche Größe
    sockSize(size) {
      const n = parseInt(size, 10);
      if (String(n) === String(size).trim()) return n < 154 ? 'S' : 'M';
      if (size === 'XS' || size === 'S') return 'M';
      return 'L';
    }
    syncSizes(size, flash = true) {
      if (!size) return;
      this.querySelectorAll('select[data-set-item]').forEach((sel) => {
        if (sel.dataset.userSet) return;
        const opts = Array.from(sel.options);
        const stutzen = (sel.dataset.ptype || '').toLowerCase().indexOf('stutzen') !== -1;
        const want = stutzen ? this.sockSize(String(size).trim()) : String(size).trim();
        const target = opts.find((o) => o.textContent.trim() === want);
        const vorher = sel.value;
        if (target) {
          sel.value = target.value;
          const priceEl = sel.closest('.pset__item')?.querySelector('[data-set-item-price]');
          if (priceEl) priceEl.textContent = money(target.dataset.price);
        }
        this.reflectSize(sel);
        // Auto-Änderung sichtbar machen: neuer Wert blinkt kurz auf
        if (flash && target && vorher !== target.value) this.flashSize(sel);
      });
      this.updateTotal();
    }
    flashSize(sel) {
      const pick = sel.closest('[data-size-pick]');
      if (!pick) return;
      const el = 'pickOpen' in pick.dataset
        ? pick.querySelector('[data-size-pill].is-active')
        : pick.querySelector('[data-size-chip]');
      if (!el) return;
      el.classList.remove('pset__flash');
      void el.offsetWidth;
      el.classList.add('pset__flash');
      setTimeout(() => el.classList.remove('pset__flash'), 1000);
    }
    updateTotal() {
      let total = this.basePrice;
      this.querySelectorAll('[data-set-item]').forEach((el) => {
        const price = el.tagName === 'SELECT' ? (el.selectedOptions[0] && el.selectedOptions[0].dataset.price) : el.dataset.price;
        total += Number(price || 0);
      });
      const out = this.querySelector('[data-set-total]');
      if (out) out.textContent = money(total);
    }
  }
  if (!customElements.get('hm-set')) customElements.define('hm-set', HmSet);
})();

// Status-Zeile und Lieferfrist folgen dem Bestand der gewählten Variante (Kevin 08.10.):
// Bestand > 0 = „Auf Lager" / 3 bis 5 Werktage, sonst „Bestellbereit" / bis zu 4 Wochen.
document.addEventListener('variant:change', (e) => {
  const v = e.detail && e.detail.variant;
  if (!v) return;
  // Das Varianten-JSON trägt keine inventory_quantity, die Menge kommt aus der Bestandskarte des Templates.
  let stock = {};
  try { stock = JSON.parse((document.querySelector('[data-stock-map]') || {}).textContent || '{}'); } catch (err) { stock = {}; }
  const lager = Number(stock[String(v.id)] || 0) > 0;
  document.querySelectorAll('[data-stock], [data-lieferzeit]').forEach((el) => {
    el.textContent = lager ? el.dataset.lager : el.dataset.bestell;
  });
});
